export const LocalStorageKey = {
  ConnectorName: 'connectorId'
} as const
